<template>
  <div id="user-view">
    <v-row>
      <v-col cols="12" md="5" lg="4">
        <bread-crumbs
          :context="{
            candidateEntryName: `${candidateEntry.firstName} ${candidateEntry.lastName}`,
          }"
        />
        <candidates-entry-bio-panel
          v-if="candidateEntry.id"
          :loading="loading"
          @refetchCandidateEntryDetails="fetchCandidateEntryDetails"
        />
      </v-col>

      <v-col cols="12" md="7" lg="8">
        <v-tabs v-model="selectedTag" show-arrows class="user-tabs">
          <v-tab v-for="tab in tabs" :key="tab.icon">
            <v-icon size="20" class="me-3">
              {{ tab.icon }}
            </v-icon>
            <span>{{ $t(tab.title) }}</span>
          </v-tab>
        </v-tabs>

        <v-tabs-items v-if="!loading" id="user-tabs-content" v-model="selectedTag" class="mt-5 pa-3" touchless>
          <v-tab-item>
            <candidates-entry-tab-files v-if="candidateEntry.id" />
          </v-tab-item>
          <v-tab-item>
            <candidates-entry-tab-job-history />
          </v-tab-item>
          <v-tab-item>
            <candidates-entry-tab-custom-fields />
          </v-tab-item>
          <v-tab-item>
            <candidates-entry-tab-consents />
          </v-tab-item>
          <v-tab-item>
            <candidates-entry-tab-internal-notes @refetch-data="fetchCandidateEntryDetails" />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, watch } from '@vue/composition-api'
import { useActions, useMutations, useState } from 'vuex-composition-helpers'
import { mdiCalendarCheckOutline, mdiFileOutline, mdiCommentOutline, mdiBriefcaseOutline, mdiDrag } from '@mdi/js'
import { useRouter } from '@core/utils'
import router from '@/router'

import CandidatesEntryBioPanel from './candidates-entry-bio-panel/CandidatesEntryBioPanel.vue'
import CandidatesEntryTabFiles from './candidates-entry-tab-files/CandidatesEntryTabFiles.vue'
import CandidatesEntryTabJobHistory from './candidates-entry-tab-job-history/CandidatesEntryTabJobHistory.vue'
import CandidatesEntryTabConsents from './candidates-entry-tab-consents/CandidatesEntryTabConsents.vue'
import CandidatesEntryTabInternalNotes from './candidates-entry-tab-internal-notes/CandidatesEntryTabInternalNotes.vue'
import CandidatesEntryTabCustomFields from './candidates-entry-tab-custom-fields/CandidatesEntryTabCustomFields.vue'
import BreadCrumbs from '@/components/files-table/BreadCrumbs.vue'
import { buildCandidatesListNavigationParams } from '@/utils/staffListNavigationParams'

export default {
  components: {
    BreadCrumbs,
    CandidatesEntryBioPanel,
    CandidatesEntryTabFiles,
    CandidatesEntryTabJobHistory,
    CandidatesEntryTabConsents,
    CandidatesEntryTabInternalNotes,
    CandidatesEntryTabCustomFields,
  },
  setup() {
    const { getCandidateEntryDetails } = useActions('candidates', ['getCandidateEntryDetails'])
    const { candidateEntry } = useState('candidates', ['candidateEntry'])
    const { SET_CANDIDATE_ENTRY_DATA } = useMutations('candidates', ['SET_CANDIDATE_ENTRY_DATA'])

    const tabs = [
      { icon: mdiFileOutline, title: 'files' },
      { icon: mdiBriefcaseOutline, title: 'jobHistory' },
      { icon: mdiDrag, title: 'customFields' },
      { icon: mdiCalendarCheckOutline, title: 'consent' },
      { icon: mdiCommentOutline, title: 'internalNotes' },
    ]

    const selectedTag = ref(null)
    const loading = ref(false)

    const fetchCandidateEntryDetails = async () => {
      loading.value = true
      await getCandidateEntryDetails({
        candidateEntryId: router.currentRoute.params.id,
        navigationParams: buildCandidatesListNavigationParams(router.currentRoute.query),
      })
      loading.value = false
    }

    const { route } = useRouter()

    watch(
      () => route.value.params.id,
      async () => {
        await fetchCandidateEntryDetails()
      },
    )

    onMounted(async () => {
      await fetchCandidateEntryDetails()
    })

    onUnmounted(() => {
      SET_CANDIDATE_ENTRY_DATA({})
    })

    return {
      fetchCandidateEntryDetails,

      tabs,
      selectedTag,
      candidateEntry,
      loading,
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
